'use client';

import { createContext, useContext } from 'react';
import { FunctionHelpers } from '@headless-workspace/utils';

export type SearchStateContextType = {
    isSearchOpen: boolean;
    searchInput: string;
};

export type SearchActionContextType = {
    onSearch: (search: string) => void;
    handleOpen: () => void;
    handleClose: () => void;
    onClearSearches: () => void;
    onSearchInputChange: (input: string) => void;
};

const searchStateContextInitialState: SearchStateContextType = {
    isSearchOpen: false,
    searchInput: '',
};

const searchActionContextInitialState: SearchActionContextType = {
    onSearch: FunctionHelpers.emptyFn,
    handleOpen: FunctionHelpers.emptyFn,
    handleClose: FunctionHelpers.emptyFn,
    onClearSearches: FunctionHelpers.emptyFn,
    onSearchInputChange: FunctionHelpers.emptyFn,
};

export const SearchStateContext = createContext<SearchStateContextType>(searchStateContextInitialState);
export const SearchActionContext = createContext<SearchActionContextType>(searchActionContextInitialState);

export const useSearchStateContext = () => useContext(SearchStateContext);
export const useSearchActionContext = () => useContext(SearchActionContext);
